module.exports = __webpack_public_path__ + "static/media/office_9.6e05b06b.jpg";